import React from 'react';

interface MetadataSectionProps {
  id?: string;
  title: string;
  description: string;
  children: React.ReactNode;
  className?: string;
  tourId?: string;
  dataTestId?: string;
  actions?: React.ReactNode;
  ariaBusy?: boolean;
  status?: {
    label: string;
    tone?: 'ready' | 'needed' | 'attention';
  };
}

const MetadataSection: React.FC<MetadataSectionProps> = ({
  id,
  title,
  description,
  children,
  className,
  tourId,
  dataTestId,
  actions,
  ariaBusy,
  status,
}) => (
  <section
    id={id}
    className={`metadata-section book-detail-secondary-surface${className ? ` ${className}` : ''}`}
    data-tour-id={tourId}
    data-testid={dataTestId}
    aria-busy={ariaBusy}
    tabIndex={id ? -1 : undefined}
  >
    <div className="metadata-section-heading book-detail-section-heading">
      <div>
        <div className="metadata-section-title-row">
          <h3>{title}</h3>
          {status ? (
            <span className={`metadata-readiness-pill metadata-readiness-pill--${status.tone || 'ready'}`}>
              {status.label}
            </span>
          ) : null}
        </div>
        <p>{description}</p>
      </div>
      {actions ? (
        <div className="metadata-section-actions">
          {actions}
        </div>
      ) : null}
    </div>
    {children}
  </section>
);

export default MetadataSection;
